import 'css-chunksrc/client/scenes/workloads/header/moveToTodayButton/styles.scss';export default {
  "moveToTodayButton": "_moveToTodayButton_193ll_1",
  "icon": "_icon_193ll_14",
  "text": "_text_193ll_19"
};